export default __webpack_public_path__ + "4e880f88f3b82849088c02e27f65339b.svg";